/** Shared grid layout constants matching Figma designs */
export const GRID_SPACING = 3;

/**
 * Horizontal page padding (theme spacing units) shared by the app header and the
 * page content, so the header — which is agnostic to a page's width mode — always
 * lines up with the page's left/right gutters.
 */
export const PAGE_PX = { xs: 6, md: 8, lg: 10, xl: 14 } as const;
export const COL_3 = { xs: 12, sm: 6, md: 3 } as const;
export const COL_2 = { xs: 12, sm: 6, md: 4 } as const;
